import { createSelector } from 'reselect'

export const selectSuggestedUsers = state => state.users.suggestedUsers || []

export const selectPreviousUserSearchResults = state =>
  state.users.previousSearchResults || {}

export const selectLastUserSearchTerm = state => state.users.lastSearchTerm

export const selectLastUserSearchResults = createSelector(
  selectPreviousUserSearchResults,
  selectLastUserSearchTerm,
  (users, term) => users[term]
)

export const selectLastUserSearchResultsSize = state =>
  state.users.lastSeenSuggestedUsersSize || 0
